import type { AppContext } from "next/app";
import { useEffect } from "react";
import { IS_PROD } from "@app/utilities/constants";
import { useRouter } from "next/router";
import axios from "axios";

export const withUpdateCmsVisit = (PageComponent: any) => {
  const WithUpdateCmsVisit = ({ ...props }: { [key: string]: any }) => {
    const router = useRouter(),
      pageUri = router.asPath.replace(/\?.*$/i, "");

    useEffect(() => {
      // Increment visits
      if (typeof navigator !== "undefined" && IS_PROD) {
        const data = {
          uri: pageUri,
        };

        axios.get("/api/analytics", {
          params: data,
        });
      }
    }, []);

    return <PageComponent {...props} />;
  };

  if (PageComponent.getInitialProps) {
    WithUpdateCmsVisit.getInitialProps = async (appCtx: AppContext) => {
      const pageProps = await (PageComponent.getInitialProps ? PageComponent.getInitialProps(appCtx) : {});

      return {
        ...pageProps,
      };
    };
  }

  return WithUpdateCmsVisit;
};
